import type { LogisticOperator, LogisticOperatorsFilter } from '../models';

export function isLogisticOperatorAutocompleteData(
  data: unknown
): data is LogisticOperator {
  return (
    typeof data === 'object' &&
    data !== null &&
    'id' in data &&
    typeof (data as LogisticOperator).id === 'string'
  );
}

export function splitExclusiveFilterFromParent(
  filter: LogisticOperatorsFilter
): {
  normalized: LogisticOperatorsFilter;
  hadConflict: boolean;
} {
  const idN = filter.selectedOperatorIdFromName?.trim() ?? '';
  const idB = filter.selectedOperatorIdFromBusiness?.trim() ?? '';
  const txtN = filter.name?.trim() ?? '';
  const txtB = filter.businessName?.trim() ?? '';
  const nameSide = idN.length > 0 || txtN.length > 0;
  const businessSide = idB.length > 0 || txtB.length > 0;

  if (!nameSide || !businessSide) {
    return { normalized: filter, hadConflict: false };
  }

  return {
    normalized: {
      ...filter,
      selectedOperatorIdFromBusiness: undefined,
      businessName: undefined,
    },
    hadConflict: true,
  };
}

export function buildLogisticOperatorsSearchFilter(
  localFilter: LogisticOperatorsFilter,
  nameInput: string,
  businessInput: string
): LogisticOperatorsFilter {
  const idName = localFilter.selectedOperatorIdFromName?.trim() ?? '';
  const idBusiness =
    localFilter.selectedOperatorIdFromBusiness?.trim() ?? '';
  const trimmedNameInput = nameInput.trim();
  const trimmedBusinessInput = businessInput.trim();

  return {
    status: localFilter.status,
    selectedOperatorIdFromName:
      idName.length > 0 ? idName : undefined,
    selectedOperatorIdFromBusiness:
      idBusiness.length > 0 ? idBusiness : undefined,
    name:
      idName.length > 0
        ? undefined
        : trimmedNameInput.length > 0
          ? trimmedNameInput
          : undefined,
    businessName:
      idBusiness.length > 0
        ? undefined
        : trimmedBusinessInput.length > 0
          ? trimmedBusinessInput
          : undefined,
  };
}

export function hasBothSearchSidesActive(
  localFilter: LogisticOperatorsFilter,
  nameInput: string,
  businessInput: string
): boolean {
  const idName = localFilter.selectedOperatorIdFromName?.trim() ?? '';
  const idBusiness =
    localFilter.selectedOperatorIdFromBusiness?.trim() ?? '';
  const hasNameSide = idName.length > 0 || nameInput.trim().length > 0;
  const hasBusinessSide =
    idBusiness.length > 0 || businessInput.trim().length > 0;
  return hasNameSide && hasBusinessSide;
}

export function hasConflictingOperatorIds(
  localFilter: LogisticOperatorsFilter
): boolean {
  const idName = localFilter.selectedOperatorIdFromName?.trim() ?? '';
  const idBusiness =
    localFilter.selectedOperatorIdFromBusiness?.trim() ?? '';
  return (
    idName.length > 0 &&
    idBusiness.length > 0 &&
    idName !== idBusiness
  );
}
